module.exports = __webpack_public_path__ + "img/section1_m.7cc98677.jpg";